import React from "react";

const AlertBox = ({ type, title, message, successMessage, error }) => {
  // Handle both old and new prop formats
  const alertType =
    type || (successMessage ? "success" : error ? "error" : null);
  const alertTitle = title || "";
  const alertMessage = message || successMessage || error || "";

  if (!alertMessage) return null;

  const getAlertStyles = () => {
    switch (alertType) {
      case "success":
        return "bg-brand-cream border-brand-charcoal/10 text-brand-charcoal";
      case "error":
        return "bg-red-50 border-red-200 text-red-800";
      default:
        return "bg-brand-cream border-brand-charcoal/10 text-brand-charcoal";
    }
  };

  return (
    <div className={`p-4 border rounded-md ${getAlertStyles()}`}>
      <div className="flex items-center">
        {alertTitle && <span className="font-medium mr-2">{alertTitle}:</span>}
        <span className="text-sm">{alertMessage}</span>
      </div>
    </div>
  );
};

export default AlertBox;
